import dynamic from 'next/dynamic';
import { RoomStayDetailsModalProps } from './RoomStayDetailsModal.types';

export const RoomStayDetailsModalMGP = dynamic<RoomStayDetailsModalProps>(() =>
  import('./RoomStayDetailsModal').then(module => module.RoomStayDetailsModal)
);
